export const getCartOpened = (state) => state.checkout.cartOpened
export const getCartItems = (state) => state.checkout.cartItems